import React from "react";
import { FiBell } from "react-icons/fi";
import useNotifications from "../../hooks/useNotifications";

export default function NotificationBell({ onClick }) {
  const notifications = useNotifications();
  const count = notifications.length;

  return (
    <div className="relative flex items-center cursor-pointer" onClick={onClick}>
      <FiBell className="w-6 h-6 text-gray-600" />
      {count > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full px-1.5 py-0.5 font-bold">
          {count}
        </span>
      )}
    </div>
  );
}
